<template>
    <div class="pm-faq-item">
        <div class="pm-faq-item-text">
            <h3 v-html="item.q"></h3>
            <div v-html="item.a"></div><br/>
            <div style="text-align: right">
                <span @click="vote(-1)" style="color: #900; flex-grow: 0; padding-right: 10px; font-weight: 600;">
                    <mdi size="18" style="color: #900;" v-show="!downVoted">mdiThumbDownOutline</mdi>
                    <mdi size="18" style="color: #900;" v-show="downVoted">mdiThumbDown</mdi>
                {{ downVotes }}</span>
                <span @click="vote(1)" style="color: green; flex-grow: 0; margin-left: 10px; padding-right: 10px; font-weight: 600;">
                    <mdi size="18" style="color: green;" v-show="!upVoted">mdiThumbUpOutline</mdi>
                    <mdi size="18" style="color: green;" v-show="upVoted">mdiThumbUp</mdi>
                    {{ upVotes }}</span>
            </div>
        </div>
    </div>
</template>

<style>
    .pm-faq-item-title {
        display: block;
        flex-grow: 1;
        padding: 12px 20px;
        font-weight: 600;
        font-size: 1.17em;
    }
    .pm-faq-item-text h3 {
        font-weight: 800;
        margin-bottom: 12px;
    }
    .pm-faq-item-text {
        background: #fff;
        padding: 32px 20px;
        margin-bottom: 10px;
    }
    .pm-faq-item-text b {
        font-weight: 600;
    }
    .pm-faq-item-text li {
        list-style-type: disc!important;
        list-style-position: outside;
    }
</style>
<script>
export default {
    props: {
        item: {
            type: Object,
        },
    },
    data: () => ({
        upVotes: 0,
        downVotes: 0,
        upVoted: false,
        downVoted: false,
    }),
    created() {
        this.getVotes();
    },
    methods: {
        getVotes() {
            this.upVotes = this.item.up + (localStorage.getItem('faqVote_' + this.item.id) === "1" ? 1 : 0);
            this.downVotes = this.item.down + (localStorage.getItem('faqVote_' + this.item.id) === "-1" ? 1 : 0);
            this.upVoted = localStorage.getItem('faqVote_' + this.item.id) === "1";
            this.downVoted = localStorage.getItem('faqVote_' + this.item.id) === "-1";
        },
        vote(val) {
            localStorage.setItem('faqVote_' + this.item.id, val.toString());
            this.getVotes();
            window.Tracker.logEvent({
                event_name: "vote_" + val > 0 ? "up" : "down",
                event_category: "faq",
                event_label: this.item.id,
            });
        }
    }
}
</script>
